package com.schoolconnect.app.feature.common

enum class ServerSortOrder {
    ASC,
    DESC;

    val apiValue: String
        get() = name.lowercase()
}

data class ServerSort(
    val field: String,
    val order: ServerSortOrder
) {
    val normalizedField: String = field.trim().takeIf { it.isNotBlank() }
        ?: error("sort field is required")
    val cacheKey: String = "$normalizedField:${order.name}"
}
